import React, { useEffect, useState } from "react";

import proofOfAuthorship from "./../assets/gallery/proof-of-authorship.png";
import certificate from "./../assets/gallery/certificate.jpeg";
import ccLicenseSharing from "./../assets/gallery/cc-license-sharing.jpeg";
import legalCertainty from "./../assets/gallery/legal-certainty.png";
import secureStorage from "./../assets/gallery/secure-storage.jpeg";
import workTypesUpload from "./../assets/gallery/work-types-upload.png";
import searchRegistry from "./../assets/gallery/search-registry.png";

const slides = [
  { src: proofOfAuthorship, alt: "Proof of authorship" },
  { src: certificate, alt: "Registration certificate" },
  { src: ccLicenseSharing, alt: "Sharing under a Creative Commons licence" },
  { src: legalCertainty, alt: "Legal certainty for creators" },
  { src: secureStorage, alt: "Secure decentralised storage" },
  { src: workTypesUpload, alt: "Uploading different types of works" },
  { src: searchRegistry, alt: "Searching the public registry" },
];

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setOpacity(0);
      setTimeout(() => {
        setCurrentIndex((currentIndex + 1) % slides.length);
        setOpacity(1);
      }, 500);
    }, 10000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  return (
    <img
      className="h-72 w-full object-contain px-6 transition-opacity duration-500 sm:h-80 md:h-96 lg:h-full lg:px-8"
      src={slides[currentIndex].src}
      alt={slides[currentIndex].alt}
      style={{ opacity }}
    />
  );
};

export default Gallery;
